import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig =
  process.env.REACT_APP_IS_PROD === 'true'
    ? {
        apiKey: 'AIzaSyD4JJrJgUM6LkQpdney6YSTOpARv7TPy94',
        authDomain: 'uvdiweb.firebaseapp.com',
        databaseURL: 'https://uvdiweb-default-rtdb.firebaseio.com',
        projectId: 'uvdiweb',
        storageBucket: 'uvdiweb.appspot.com',
        messagingSenderId: '301207873441',
        appId: '1:301207873441:web:442bb6c9be0d3048954de0',
        measurementId: 'G-60SSS3KG42',
      }
    : {
        apiKey: 'AIzaSyCAjADi7JcoBTtUHAvQ9HdUnuhY71G66Bo',
        authDomain: 'uvdi-old-staging.firebaseapp.com',
        databaseURL: 'https://uvdi-old-staging-default-rtdb.firebaseio.com',
        projectId: 'uvdi-old-staging',
        storageBucket: 'uvdi-old-staging.appspot.com',
        messagingSenderId: '891769314371',
        appId: '1:891769314371:web:a6ca80ad572c0c09eb48f6',
        measurementId: 'G-3CJ8ZDFQG3',
      };

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
